import { render, staticRenderFns } from "./NoticeMove.vue?vue&type=template&id=2ed7f488&scoped=true"
import script from "./NoticeMove.vue?vue&type=script&lang=js"
export * from "./NoticeMove.vue?vue&type=script&lang=js"
import style0 from "./NoticeMove.vue?vue&type=style&index=0&id=2ed7f488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed7f488",
  null
  
)

export default component.exports